import { useEffect, useState } from "react";
import Lenis from "lenis";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Lines from "../components/Lines";
import Catalog from "../components/Catalog";
import Showcase from "../components/Showcase";
import Quality from "../components/Quality";
import About from "../components/About";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  const [lineFilter, setLineFilter] = useState("todas");

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-cream font-body text-neutral-900">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Lines onSelect={setLineFilter} />
        <Catalog lineFilter={lineFilter} setLineFilter={setLineFilter} />
        <Showcase />
        <Quality />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
